import { IS_MODE_REGRESSION } from '@/define/env';
/**
 * particle オプション設定（デフォルト）
 * @param option.particleColor particle 色指定（カラーコード）
 * @returns
 */
export const defaultOptions = ({ particleColor, }) => ({
    fullScreen: {
        enable: false,
    },
    particles: {
        color: {
            value: particleColor,
        },
        links: {
            color: particleColor,
            distance: 150,
            enable: true,
            opacity: 0.4,
            width: 1,
        },
        move: {
            enable: true,
            outModes: {
                default: 'out',
            },
            random: false,
            speed: 2,
            straight: false,
        },
        number: {
            density: {
                area: 1440,
                enable: false,
            },
            value: 50,
        },
        opacity: {
            value: 0,
        },
    },
    style: {
        display: IS_MODE_REGRESSION ? 'none' : undefined,
    },
});
